import {
  useCheckPermissions as libUseCheckPermissions,
  PermissionCheck as LibPermissionCheck,
  PermissionsProvider as LibPermissionsProvider,
} from 'react-permissions-dynamic';
import type {
  PermissionCheckProps as LibPermissionCheckProps,
  PermissionsProviderProps as LibPermissionsProviderProps,
} from 'react-permissions-dynamic';

import { useAuth } from '../User';

type PermissionCheckProps = LibPermissionCheckProps<PermissionType> & {
  type?: 'every' | 'some';
};
type PermissionsProviderProps = LibPermissionsProviderProps<PermissionType>;

const PermissionCheck: React.FC<PermissionCheckProps> = ({
  type = 'every',
  ...props
}) => {
  const { isSuper } = useAuth();

  const action = Array.isArray(props.action) ? props.action : [props.action];
  const flattenedAction = action.flat();
  const skipCheck = isSuper || !action.length;

  return (
    <LibPermissionCheck
      {...props}
      action={flattenedAction}
      isAllowed={allowed =>
        skipCheck || type === 'every'
          ? allowed.every(c => !!c)
          : allowed.some(c => !!c)
      }
    />
  );
};
const PermissionsProvider =
  LibPermissionsProvider as React.FC<PermissionsProviderProps>;

export { PermissionCheck, PermissionsProvider };
export const useCheckPermissions = (
  actions: PermissionType[] | PermissionType
) => {
  const actionsArray = Array.isArray(actions) ? actions : [actions];
  const result = libUseCheckPermissions(Array.from(new Set(actionsArray)));
  const { isSuper } = useAuth();

  return result.map(item => ({ ...item, allowed: item.allowed || isSuper }));
};
